export default "__VITE_ASSET__BjNOyI6e__"